export default __webpack_public_path__ + "095159fb2b27ce36881239f952e54c85.png";